<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextTruncationSingleLine',
})
</script>

<template>
  <span class="span">
    <slot />
  </span>
</template>

<style lang="sass" scoped>
  .span
    width: 100%
    min-width: 0
    display: block
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
</style>
